import { apiSlice } from "../api/apiSlice";

export const usersApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getStudents: builder.query({
			query: () => "/users?role=student",
		}),
	}),
});

export const { useGetStudentsQuery } = usersApi;
